import React from 'react';

import Icon from '../Icon/Icon';

const ResponsiveDrawNoneIcon = (props) => {
    return (
        <Icon width='48' height='48' {...props}>
            <g transform='translate(6 6)' stroke='#272A33' strokeWidth='2' fill='none' fillRule='evenodd'>
                <circle cx='18' cy='18' r='17' />
                <path strokeLinecap='round' d='M29 7 7 29' />
            </g>
        </Icon>
    );
};

export default ResponsiveDrawNoneIcon;
